import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import moment from 'moment';
import { Program } from "../../../../interfaces/program";
import { getProgram } from "../../../../services/program";
import { ProgramNew } from "./program-new";
import { ProgramEdit } from "./program-edit";
import { ProgramDelete } from "./program-delete";
import { ProgramMembers } from "./program-members";
import { Link } from "react-router-dom";
import { UserContext } from "../../../../App";

export function ProgramList() {
    const { userProfile } = useContext(UserContext);

    const is_athlete = (userProfile.role.filter((r: any) => r.id == 'badminton_athlete').length > 0);
    const is_coach = (userProfile.role.filter((r: any) => r.id == 'badminton_coach').length > 0);
    const is_manager = (userProfile.role.filter((r: any) => r.id == 'badminton_manager').length > 0);
    const can_create_programs = (is_manager || is_coach) && !is_athlete; // Solo managers y coaches pueden crear programas

    const [program, setProgram] = useState<Program[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showMembers, setShowMembers] = useState(false);
    const [selectedId, setSelectedId] = useState(0);

    useEffect(() => {
        getProgram()
            .then((response: any) => {
                setProgram(response.data);
            })
            .catch((error: any) => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club.value;

        getProgram(s)
            .then(response => {
                setProgram(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: Program) => {
        const newProgram = [
            s,
            ...program
        ];
        setProgram(newProgram);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleMembers = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        const id = parseInt(event.currentTarget.dataset.id);
        setSelectedId(id);
        setShowDelete(false);
        setShowEdit(false);
        setShowMembers(true);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        const id = parseInt(event.currentTarget.dataset.id);
        setSelectedId(id);
        setShowMembers(false);
        setShowEdit(false);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newProgram = program.filter((m: Program) => m.id != id);
        setProgram(newProgram);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        const id = parseInt(event.currentTarget.dataset.id);
        setSelectedId(id);
        setShowMembers(false);
        setShowDelete(false);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedProgram: Program) => {
        setSelectedId(0);
        setShowMembers(false);
        const newProgram = program.map((m: Program) => {
            if (m.id == changedProgram.id) {
                return changedProgram;
            } else {
                return m;
            }
        });
        setProgram(newProgram);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    return (
        <div className="program-list-container">
            <h1>
                { t("Programs")}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="text" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="grid-container">
                <Row>
                    { program.map((p: Program) => {
                        // const numPhases = s.phases.length;
                        /*const numExercises = s.phases.reduce((previousValue, currentValue: ProgramPhase) => {
                            return previousValue + currentValue.exercises.length
                         } , 0);*/
                        return <Col key={ 'program-' + p.id } xs={12} md={6} lg={4} xl={3}>
                            <div className="program-card">
                                <div className="inner">
                                    <div className="name">
                                        <Link to={ '/programs/' + p.id }  title={ p.name }>
                                            { p.name }
                                        </Link>
                                    </div>
                                    <div className="start">
                                        { t("Start date") }: {moment(p.date_start).format('DD/MM/YYYY') }
                                    </div>
                                    <div className="end">
                                        { t("End date") }: {moment(p.date_end).format('DD/MM/YYYY') }
                                    </div>
                                    <div className="author">
                                        { t("Author") }: { p.user_display_name }
                                    </div>
                                </div>
                                <div className="actions">
                                    { !is_athlete && ((is_manager) || (userProfile.id == p.created_by)) &&
                                        <a href="#" className="icon-link edit" title={ t("edit") } onClick={ handleEdit } data-id={ p.id }>
                                            <i className="bi bi-pencil-square"></i>
                                        </a>
                                    }
                                    { !is_athlete && ((is_manager) || (userProfile.id == p.created_by)) &&
                                        <a href="#" className="icon-link members" title={ t("Members") } onClick={ handleMembers } data-id={ p.id }>
                                            <i className="bi bi-people"></i>
                                        </a>
                                    }
                                    { !is_athlete && ((is_manager) || (userProfile.id == p.created_by)) &&
                                        <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ p.id }>
                                            <i className="bi bi-trash"></i>
                                        </a>
                                    }
                                </div>
                            </div>
                        </Col>
                    })}
                </Row>
            </div>
            {can_create_programs && <a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>}
            { showAddNew && can_create_programs &&
                <ProgramNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <ProgramEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showMembers && (selectedId != 0) &&
                <ProgramMembers
                    program_id={ selectedId }
                    created_by={ program.find(p => p.id == selectedId)?.created_by || 0 }
                    onClose={ handleEditOnClose }
                />
            }
            { showDelete && (selectedId != 0) &&
                <ProgramDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
        </div>
    )
}